import React from 'react';
import { Link } from 'react-router-dom';
import { Badge } from '@burna/monster-design-system';
import RowItem from 'components/row-item';
import styles from './index.module.scss';
import { copyToClipboard, getFileSizeString } from 'utils';
import moment from 'moment';
import useDownload from 'hooks/useDownload';

const RowItemFileList = ({
  data,
  inSelectMode,
  onHold,
  onSwipe,
  selectedPaths,
  handleSelect
}) => {
  const { startDownload } = useDownload();

  const handleDownload = downloadPath => {
    startDownload({
      downloadPath,
      showErrorAlert: true
    });
  };

  return (
    <div className={styles.list}>
      {data.map(item => (
        <RowItem
          key={item.uploadDate}
          title={item.managePath.substring(
            item.managePath.lastIndexOf('/') + 1
          )}
          isSelectable={inSelectMode}
          checked={selectedPaths.has(item.managePath)}
          onChange={handleSelect(item)}
          onHold={onHold?.bind(null, item)}
          onSwipe={onSwipe?.bind(null, item)}>
          <RowItem.Actions>
            <RowItem.Action
              icon="download"
              onClick={() => handleDownload(item.downloadPath)}
            />
            <RowItem.Action
              icon="external-link"
              as={Link}
              to={new URL(item.managePath).pathname}
              target="_blank"
            />
            <RowItem.Action
              icon="copy"
              value={item.downloadPath.replace(/(?!^) (?!$)/g, '%20')}
            />
          </RowItem.Actions>
          <RowItem.Content>
            <RowItem.ContentItem title="File Size">
              {getFileSizeString(item.fileSize)}
            </RowItem.ContentItem>
            <RowItem.ContentItem title="Uplaod Date">
              <div className={styles.date}>
                <span>{moment(item.uploadDate).format('hh:mm A')}</span>
                <span>{moment(item.uploadDate).format('MMM DD, YYYY')}</span>
              </div>
            </RowItem.ContentItem>
            <RowItem.ContentItem title="Last Download">
              {item.lastDownloadDate ? (
                <div className={styles.date}>
                  <span>{moment(item.lastDownloadDate).format('hh:mm A')}</span>
                  <span>
                    {moment(item.lastDownloadDate).format('MMM DD, YYYY')}
                  </span>
                </div>
              ) : (
                <Badge
                  size="md"
                  type="success"
                  label="Ready to download"
                  icon="arrow-right"
                  iconPlacement="trailing"
                />
              )}
            </RowItem.ContentItem>
          </RowItem.Content>
        </RowItem>
      ))}
    </div>
  );
};

export default RowItemFileList;
